import {
  formatTotal,
  formatTopFive,
  formatTotalsList,
  formatRushData,
} from "./Formatters";
import { HTTPMethods } from "../../yoello-lib/modules/API/API";
import IVenue from "../../interfaces/IVenue";
import moment from "moment-timezone";

interface IHandler {
  apiData: unknown;
  isLoading: boolean;
  isError: boolean;
  callAPI: Function;
  cancelRequest: () => void;
}

export const fetchTopFive = (
  handler: IHandler,
  venues: IVenue[],
  startDate: number | Date,
  endDate: number | Date,
  category: string,
  setTopFive: Function,
  formatCurrency: Function,
  useSubcategories?: boolean
) => {
  const mStart = moment(startDate);
  mStart.set({ hour: 0, minute: 0, second: 0 });
  const mEnd = moment(endDate);
  mEnd.set({ hour: 23, minute: 59, second: 59 });

  const categoryParams = useSubcategories
    ? { subcategory: category }
    : { category: category };

  //@ts-ignore
  const promiseList = venues.map((venue, i) => {
    return handler.callAPI(HTTPMethods.GET, {
      preQuery: venue?.id || "",
      params: {
        from: mStart.utc().format("YYYY-MM-DD HH:mm:ss"),
        to: mEnd.utc().format("YYYY-MM-DD HH:mm:ss"),
        ...categoryParams,
      },
    });
  });

  Promise.all(promiseList)
    .then((responses: any[]) => {
      let objects: any[] = [];

      responses.forEach((res: any) => {
        res.objects.forEach((obj: any) => objects.push(obj));
      });

      objects = objects
        .sort((a, b) => b.total_revenue - a.total_revenue)
        .slice(0, 5);

      const total_revenue = responses.reduce(
        (acc, curr) => acc + curr.total_revenue.total_revenue,
        0
      );
      setTopFive(
        formatTopFive(objects, formatCurrency),
        formatTotal(total_revenue, formatCurrency)
      );
    })
    .catch((error: Error) => {
      setTopFive(
        [],
        ''
      );
    });
};

export const fetchTotalsList = async (
  handler: IHandler,
  venues: IVenue[],
  startDate: number | Date,
  endDate: number | Date,
  setTotalsList: Function,
  formatCurrency: Function
) => {
  const mStart = moment(startDate);
  mStart.set({ hour: 0, minute: 0, second: 0 });
  const mEnd = moment(endDate);
  mEnd.set({ hour: 23, minute: 59, second: 59 });
  //@ts-ignore
  const promiseList = venues.map((venue, i) => {
    return handler.callAPI(HTTPMethods.GET, {
      preQuery: venue?.id || "",
      params: {
        from: mStart.utc().format("YYYY-MM-DD HH:mm:ss"),
        to: mEnd.utc().format("YYYY-MM-DD HH:mm:ss"),
      },
    });
  });

  Promise.all(promiseList)
    .then((responses: any) => {
      //@ts-ignore
      const venueData = responses.map((res, i) => {
        return {
          ...venues[i],
          venueStatistic: res,
        };
      });

      const result = responses.reduce(
        //@ts-ignore
        (acc, curr) => {
          const calculatedData = {
            sum_order_spend: {
              value: acc.sum_order_spend.value + curr.sum_order_spend.value,
            },
            count_order_spend: {
              value: acc.count_order_spend.value + curr.count_order_spend.value,
            },

            sum_gratuity: {
              value: acc.sum_gratuity.value + curr.sum_gratuity.value,
            },
            count_gratuity: {
              value: acc.count_gratuity.value + curr.count_gratuity.value,
            },

            count_of_orders: {
              value: acc.count_of_orders.value + curr.count_of_orders.value,
            },
            total_gratuity: {
              value: acc.total_gratuity.value + curr.total_gratuity.value,
            },
            total_revenue: {
              value: acc.total_revenue.value + curr.total_revenue.value,
            },
            total_unique_customers: {
              value:
                acc.total_unique_customers.value +
                curr.total_unique_customers.value,
            },
          };

          return calculatedData;
        },
        {
          sum_order_spend: { value: 0 },
          count_order_spend: { value: 0 },
          sum_gratuity: { value: 0 },
          count_gratuity: { value: 0 },
          avg_gratuity: { value: 0 },
          avg_order_spend: { value: 0 },
          count_of_orders: { value: 0 },
          total_gratuity: { value: 0 },
          total_revenue: { value: 0 },
          total_unique_customers: { value: 0 },
        }
      );
      result.avg_gratuity = {
        value: result.sum_gratuity.value / (result.count_gratuity.value || 1),
      };
      result.avg_order_spend = {
        value:
          result.sum_order_spend.value / (result.count_order_spend.value || 1),
      };

      setTotalsList(formatTotalsList(result, formatCurrency), venueData);
    })
    .catch((error: Error) => {
      console.log("Error fetching data", error);
    });
};

export const fetchRushData = (
  handler: IHandler,
  venue: IVenue | undefined,
  startDate: number | Date,
  endDate: number | Date,
  setRushData: Function
) => {
  const mStart = moment(startDate);
  mStart.set({ hour: 0, minute: 0, second: 0 });
  const mEnd = moment(endDate);
  mEnd.set({ hour: 23, minute: 59, second: 59 });
  const timezone = moment().tz(moment.tz.guess()).format("z");
  handler
    .callAPI(HTTPMethods.GET, {
      preQuery: venue?.id || "",
      params: {
        from: mStart.utc().format("YYYY-MM-DD HH:mm:ss"),
        to: mEnd.utc().format("YYYY-MM-DD HH:mm:ss"),
        timezone: timezone,
        interval: "hour",
      },
    })
    .then((response: any) => {
      const formattedData = formatRushData(response.objects);
      setRushData(formattedData);
    })
    .catch((error: Error) => {
      //@TODO
    });
};
